<template>
	<div class="search">
		<div class="top">
			<van-icon name="scan" @click="scanCode"></van-icon>
			<div class="input-wrap">
				<!-- 左侧搜索图标 -->
				<van-icon name="search" class="icon-left" @click="search" />

				<!-- 输入框（自带圆形 x） -->
				<van-field v-model="value" placeholder="搜索商品" @input="goSearch" clearable />

			</div>

			<p @click="cancel">返回</p>
		</div>
		<div class="scroll">
			<template v-if="!value">
				<div class="list" v-if="historyDatas.length">
					<p>历史搜索</p>
					<div class="wrap">
						<p v-for="(value, index) in historyDatas" :key="index" @click="handleSearch(value)">{{value}}
						</p>
					</div>
				</div>
				<div class="list" v-if="hotDatas.length">
					<p>热门搜索</p>
					<div class="wrap">
						<p v-for="(value, index) in hotDatas" :key="index" @click="handleSearch(value)">{{value}}</p>
					</div>
				</div>
			</template>
			<!-- 关键词联想列表（图2） -->
			<div class="keyword-list" v-if="searchMode === 'keyword' && value && keywordList.length && !searching">
				<p v-for="(item, index) in keywordList" :key="index" @click="handleKeywordClick(item)"
					v-html="highlightKeyword(item)"></p>
			</div>

			<product-list v-if="searching" :datas="datas" />
			<div class="app-bottom" v-if="value">{{datas.length ? '您已滑到最底部~' : '暂无数据'}}</div>
		</div>
	</div>
</template>

<script>
	import CommonService from '@/io/common.js';
	import ProductList from '@/components/ProductList.vue';

	export default {
		name: 'Search',
		data() {
			return {
				value: '',
				datas: [],
				keywordList: [], // 🔥 新增：关键词联想
				searching: false, // 🔥 是否已进入商品搜索态
				historyDatas: [],
				hotDatas: [],

				// 🔥 搜索模式：
				// 'direct'  = 输入即搜索商品（当前新需求）
				// 'keyword' = 先关键词联想，再点关键词搜索（之前需求）
				searchMode: 'direct',
				// searchMode: 'keyword',

				goSearch: null

				// goSearch: this.debounce(this.fetchKeywords, 300)
			}
		},
		created() {
			this.goSearch = this.debounce(this.handleInputSearch, 300);
		},

		watch: {
			value: {
				handler(newValue, oldValue) {
					if (!newValue) {
						this.datas = [];
						this.initDatas();
					}
				},
				immediate: true
			}
		},
		components: {
			ProductList,
		},
		methods: {
			handleInputSearch() {
				if (!this.value) return;

				if (this.searchMode === 'direct') {
					// ✅ 模式一：直接搜索商品
					this.search();
				} else {
					// ✅ 模式二：关键词联想
					this.fetchKeywords();
				}
			},
			clearValue() {
				this.value = '';
				this.datas = [];
				this.initDatas();
			},
			cancel() {
				this.value = '';
				this.datas = [];
				this.$store.state.showSearchLayer = false;
			},
			fetchKeywords() {
				if (this.searchMode !== 'keyword') return;

				if (!this.value) {
					this.keywordList = [];
					return;
				}

				this.searching = false;
				this.datas = [];

				CommonService.keywordSearch(this.value).then(res => {
					this.keywordList = res.data || [];
				});
			},
			handleKeywordClick(word) {
				if (this.searchMode !== 'keyword') return;

				this.value = word;
				this.keywordList = [];
				this.searching = true;
				this.search();
			},

			highlightKeyword(word) {
				if (!this.value) return word;

				const reg = new RegExp(this.value, 'gi');
				return word.replace(reg, match => {
					return `<span class="keyword-highlight">${match}</span>`;
				});
			},
			handleSearch(keywords) {
				this.value = keywords;
				this.search();
			},
			initDatas() {
				this.$toast.loading({
					message: '加载中...',
					duration: 0
				});
				CommonService.searchHistoryList().then(res => {
					this.historyDatas = res.data.user_search_history;
					this.hotDatas = res.data.hot_search;
				}).catch(err => {}).finally(() => {
					this.$toast.clear();
				});
			},
			search() {
				if (!this.value) return;

				this.searching = true;
				this.keywordList = [];

				let merchantId;
				let cart;

				this.$toast.loading({
					message: '加载中...',
					duration: 0
				});

				CommonService.allInfo()
					.then(res => {
						merchantId = res.merchant.id;
						cart = res.cart.cart;
						return CommonService.search(this.value, null, merchantId);
					})
					.then(response => {
						CommonService.addSearchHistory(this.value);
						this.datas = response.goods_list.map(val => {
							val.merchantId = merchantId;
							val.image = `${process.env.VUE_APP_IMAGE_URL}${val.image}`;
							val.number = 0;
							cart.forEach(m => {
								if (m.goods_id === val.id) {
									val.number = m.num * 1;
								}
							});
							return val;
						});
					})
					.finally(() => {
						this.$toast.clear();
					});
			}

		},
	}
</script>

<style lang="less" scoped>
	@import '../assets/styles/tools.less';

	.search {
		height: 100%;
		overflow: hidden;

		.top {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 32 * @r;
			margin-bottom: 40 * @r;

			&>.van-icon {
				font-size: 40 * @r;
				color: #696969;
				margin-left: 34 * @r;
			}

			.input-wrap {
				display: flex;
				align-items: center;
				background-color: #F3F4F7;
				flex: 1;
				padding: 0 24 * @r;
				border-radius: 28 * @r;
				margin: 0 24 * @r 0 34 * @r;
				border: 2 * @r solid #F24C4C; // 🔥 新增：搜索框红色边框

				.icon-left {
					font-size: 36 * @r;
					color: #959AA3;
					margin-right: 16 * @r;
				}

				.icon-clear {
					font-size: 32 * @r;
					color: #B0B4BC;
					margin-left: 16 * @r;
				}

				/deep/ .van-cell {
					flex: 1;
					background-color: transparent;
					padding: 8 * @r 0;

					&::after {
						display: none;
					}

					.van-field__body {
						input {
							text-align: left; // 🔥 和图二一致
							font-size: 24 * @r;
						}
					}
				}
			}

			&>p {
				font-size: 26 * @r;
				color: #82858B;
				margin-right: 30 * @r;
			}
		}

		.list {
			padding: 0 40 * @r;
			margin-bottom: 60 * @r;

			&>p {
				font-size: 26 * @r;
				color: #82858B;
				margin-bottom: 22 * @r;
			}

			.wrap {
				display: flex;
				flex-wrap: wrap;
				margin: -13 * @r -10 * @r;

				p {
					height: 56 * @r;
					display: flex;
					align-items: center;
					font-size: 26 * @r;
					color: #82858B;
					background-color: #F3F4F7;
					padding: 0 24 * @r;
					border-radius: 28 * @r;
					margin: 13 * @r 10 * @r;
				}
			}
		}

		.product-list {
			padding: 0 40 * @r;
		}

		.scroll {
			height: calc(100% - 136 * @r);
			overflow: auto;
		}
	}

	.keyword-list {
		padding: 0 40 * @r;

		p {
			height: 88 * @r;
			display: flex;
			align-items: center;
			font-size: 28 * @r;
			color: #333;
			border-bottom: 1px solid #f0f0f0;
		}

		/* ✅ 关键：穿透 scoped，让 v-html 的 span 也能命中 */
		/deep/ .keyword-highlight {
			color: #F24C4C !important;
			font-weight: 600;
		}
	}
</style>